import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {
    Flex,
    Text,

    /* Hooks */
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'

const ItemCount = ({count}) => {
    const styles = useMultiStyleConfig('PageFilters')

    return (
        <Text {...styles.itemCount}>
            <FormattedMessage
                id="product_list.item_count"
                defaultMessage="{count} {count, plural, one {Item} other {Items}}"
                values={{count: count || 0}}
            />
        </Text>
    )
}

ItemCount.propTypes = {
    count: PropTypes.number
}

export default ItemCount
